export const sanitizeAccount = function(account) {
    account.branding = normalizeBranding(account.branding);
    account.address = account.address || {};
};

const normalizeBranding = function(branding) {
    return {
        logoUrl: branding.logoUrl,
        logoContainsName: branding.logoContainsName,
        primary: branding.primary || branding.primaryColor,
        secondary: branding.secondary || branding.secondaryColor,
    }
};

export const standardizeBranding = function(branding) {
    return {
        logoUrl: branding.logoUrl,
        logoContainsName: branding.logoContainsName,
        primaryColor: branding.primary,
        secondaryColor: branding.secondary,
    }
};
